import styled from 'styled-components';
import { colors } from '../../../../styles/colors';
import { fontFamily, space, text } from '../../../../styles/onboardingUiTokens';
import { Body } from '../typography/Body';

export type OnboardingPriceCardProps = {
  /** Struck-through original amount, e.g. "150 €". */
  originalPrice: string;
  /** The big amount, e.g. "0 €". */
  price: string;
  /** Text after the amount, e.g. "für dich". */
  suffix: string;
  /** One small line under the price row. */
  note: string;
};

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.xs};
  padding: ${space.md};
`;

const PriceRow = styled.p`
  margin: 0;
  display: flex;
  align-items: baseline;
  gap: ${space.sm};
  flex-wrap: wrap;
  color: ${colors.medium};
  font-family: ${fontFamily.ubuntu};
  font-size: ${text.body.fontSize};
`;

const Original = styled.s`
  text-decoration-thickness: 1px;
`;

const Price = styled.strong`
  font-family: ${fontFamily.lora};
  font-weight: 700;
  font-size: 1.875rem;
  line-height: 1;
  color: ${colors.dark};
`;

export function OnboardingPriceCard({ originalPrice, price, suffix, note }: OnboardingPriceCardProps) {
  return (
    <Card>
      <PriceRow>
        <Original>{originalPrice}</Original>
        <Price>{price}</Price>
        <span>{suffix}</span>
      </PriceRow>
      <Body variant="document" size="small" tone="muted">
        {note}
      </Body>
    </Card>
  );
}
